import { User } from './store/userSlice';

export const fetchAPI = async (
  user: User | undefined,
  method: string,
  path: string,
  data?: any,
): Promise<Response> => {
  // Use localhost for development, production URL for production
  const baseUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001'
    : (process.env.REACT_APP_API_URL || 'https://caapi.sitewalker.org');


  const url = `${baseUrl}/${path}`;
  const headers = user
    ? {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    }
    : {
      'Content-Type': 'application/json',
      Authorization: 'None',
    };

  console.log('fetchAPI', url, method, data, headers);

  try {
    const response = await fetch(url, {
      method,
      body: data ? JSON.stringify(data) : undefined,
      headers,
    });

    return response;
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};

// Wrapper function that handles 401 errors
export const fetchAPIWithAuth = async (
  user: User | undefined,
  method: string,
  path: string,
  data?: any,
  onUnauthorized?: () => void,
): Promise<Response> => {
  const response = await fetchAPI(user, method, path, data);

  if (response.status === 401) {
    console.log('Unauthorized access detected, redirecting to login');
    // Clear user data from localStorage
    localStorage.removeItem('user');
    // Call the unauthorized callback if provided
    if (onUnauthorized) {
      onUnauthorized();
    }
    // Redirect to login page
    window.location.href = '/login';
    throw new Error('Unauthorized access');
  }

  return response;
};
